import { defaults } from 'lodash/fp';

export const formatNumber = (number, options) => {
    const optionsWithDefaults = defaults({ decimals: 0, locale: 'en-US' }, options);
    return new Intl.NumberFormat(optionsWithDefaults.locale, {
        minimumFractionDigits: optionsWithDefaults.decimals,
        maximumFractionDigits: optionsWithDefaults.decimals,
        ...optionsWithDefaults,
    }).format(number || 0);
};

export const pxToNumber = px => parseInt(px.slice(0, -2), 10);
